import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { FieldStates } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult, StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import {  QualityRegisterOrderModel, QualityRegisterOrderStore } from '../../../models';
import { setFormValue } from 'sos-eservice-common/js/Redux/Actions';
import { getErrorMessageByFieldName } from '../../../utilities/helpers';
export interface Step2Props extends StepChildProps {
  Translate?: translateFunc;
  setFormValue?: typeof setFormValue;
  formModel: QualityRegisterOrderModel;
  hasHitSummary: boolean;
  orderId: string;
  validationResults: ValidationResult[];
  stepValidationMap: StepValidationMap;
}
export interface Step2State {
  isValid: boolean;
  stepId: number;
}

class Step2 extends React.Component<Step2Props, Step2State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isValid: this.props.stepState.isDone,
      stepId: this.props.stepState.stepId
    };
  }
  getTitle = () => 'Beställare';

  onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  }

  componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle()
    });
  }
  render() {
    const {
      Translate,
      formModel,
      hasHitSummary,
      orderId,
      validationResults
    } = this.props;
    const noResearchOrderId = !orderId;
    return (
      <div id='step2' tabIndex={-1}>
        <div className='form-group-small'>
          <div>
            <h2 className='inlineblock'>
              {Translate('/qualityFormPage/contactPerson')}
            </h2>
          </div>
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/namn') + ' *'}
            placeholder={Translate('/general/contact/fnAndEn')}
            value={_.get(formModel, 'ContactPerson.Name')}
            isRequired={true}
            maxLength={160}
            fieldName='ContactPerson.Name'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'ContactPerson.Name'
            )}
            autoComplete="name"
          />
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/epost') + ' *'}
            placeholder={Translate('/general/contact/abcmail')}
            value={_.get(formModel, 'ContactPerson.Email')}
            maxLength={160}
            isRequired={true}
            fieldName='ContactPerson.Email'
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'ContactPerson.Email'
            )}
            autoComplete="email"
          />
        </div>

        <hr className='formdivider' />

        <div className='form-group-small'>
          <div>
            <h2 className='inlineblock'>
              {Translate('/qualityFormPage/cpuaTitle')}
            </h2>
          </div>
        </div>

        <div className='form-group-small'>
          <TextInput
            label={Translate('/general/contact/ogNamn1') + ' *'}
            placeholder={Translate('/general/contact/ogNamn2')}
            value={_.get(formModel, 'Organisation')}
            isRequired={true}
            fieldName='Organisation'
            maxLength={160}
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(
              validationResults,
              'Organisation'
            )}
            autoComplete="organization"
          />
        </div>
      </div>
    );
  }
}

const mapState2Props = (state: QualityRegisterOrderStore) => {
  return {
    Translate: makeTranslator(state.globals.translations),
    formModel: state.formModel,
    orderId: state.globals.orderId,
    hasHitSummary: state.globals.hasHitSummary,
    validationResults: state.validationState.validationResults,
    stepValidationMap: state.validationState.stepValidationMap
  } as Partial<Step2Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    setFormValue: bindActionCreators(setFormValue, dispatch)
  };
};

const StepTwo = connect(
  mapState2Props,
  mapDispatch2Props
)(Step2);
export { StepTwo };
